<template>
	<div
		class="sticky top-14 sm:top-16 left-0 right-0 z-40 bg-gradient-to-b from-white via-white to-white/95 backdrop-blur-sm border-b border-blue-200 shadow-md"
	>
		<div class="flex justify-center w-full max-w-3xl mx-auto px-3 py-2 sm:py-3">
			<div
				class="flex items-center justify-between w-full gap-1 sm:gap-2 text-xs text-gray-600 bg-white/80 hover:bg-blue-50/80 px-3 sm:px-4 py-2 sm:py-2.5 rounded-lg border border-gray-300 transition-colors"
			>
				<!-- Scale point 1 - Light colorful blue border -->
				<span class="flex items-center gap-1 sm:gap-1.5">
					<span
						:class="[
							'w-6 h-6 sm:w-7 sm:h-7 rounded-full border text-xs flex items-center justify-center transition-all font-medium',
							selectedValue === 1
								? 'bg-blue-100 border-blue-400 text-gray-600'
								: 'bg-white border-blue-400 text-gray-600',
						]"
						>1</span
					>
					<span class="text-[10px] sm:text-xs whitespace-nowrap">Trifft gar nicht zu</span>
				</span>

				<!-- Separator -->
				<span class="text-gray-400 mx-0.5 sm:mx-1 text-xs hidden sm:inline">•••</span>

				<!-- Scale point 3 - Medium blue border, filled only if selected -->
				<span class="flex items-center gap-1 sm:gap-1.5 hidden sm:flex">
					<span
						:class="[
							'w-6 h-6 sm:w-7 sm:h-7 rounded-full border text-xs flex items-center justify-center transition-all font-medium',
							selectedValue === 3
								? 'bg-blue-600 border-blue-600 text-white'
								: 'bg-white border-blue-400 text-gray-600',
						]"
						>3</span
					>
					<span class="text-xs whitespace-nowrap">Neutral</span>
				</span>

				<!-- Separator -->
				<span class="text-gray-400 mx-0.5 sm:mx-1 text-xs hidden sm:inline">•••</span>

				<!-- Scale point 5 - Full blue border, filled only if selected -->
				<span class="flex items-center gap-1 sm:gap-1.5">
					<span
						:class="[
							'w-6 h-6 sm:w-7 sm:h-7 rounded-full border text-xs flex items-center justify-center transition-all font-medium',
							selectedValue === 5
								? 'bg-blue-600 border-blue-600 text-white'
								: 'bg-white border-blue-600 text-gray-600',
						]"
						>5</span
					>
					<span class="text-[10px] sm:text-xs whitespace-nowrap">Trifft voll zu</span>
				</span>
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useWizardStore } from '@/stores/wizard';

const wizardStore = useWizardStore();

// Get the currently selected answer from the wizard store
// This will be 0 if no answer is selected
const selectedValue = computed(() => {
	const currentSectionId = wizardStore.currentSectionId;
	if (!currentSectionId) return 0;

	// Get all questions in current section and find if any are selected
	// For now, we'll show the most recently selected value across all questions
	const answers = wizardStore.answers;
	const values = Object.values(answers).filter((v) => typeof v === 'number' && v > 0);
	return values.length > 0 ? (values[values.length - 1] as number) : 0;
});
</script>
